import { useState, useEffect, useRef } from "react";
import "./dropdown.css";
import indiaFlag from "../../assets/india.webp";
import germanyFlag from "../../assets/germany.jpeg";

function Dropdown() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="Pages-dropdown" ref={dropdownRef}>
      <dropdown
        className="Pages-dropdown-button"
        onClick={toggleDropdown}
        aria-haspopup="true"
        aria-expanded={isDropdownOpen}
      >
        Pages
      </dropdown>
      <ul
        className={`dropdown-menu ${
          isDropdownOpen ? "dropdown-menu-enter-active" : "dropdown-menu-enter"
        }`}
      >
        <li>
          <img src={indiaFlag} alt="" className="flag" />
          <a
            href="https://marketmindsdigitalsolutions.com/"
            className="us-page"
            target="_blank"
            rel="noopener noreferrer"
          >
           India Website
          </a>
        </li>
        <li>
          <img src={germanyFlag} alt="" className="flag" />
          <a
            href="https://germany.marketmindsdigitalsolutions.com"
            className="germany-page"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span>Germany Website – Coming soon</span>
          </a>
        </li>
      </ul>
    </div>
  );
}

export default Dropdown;
